import React from 'react';
import { Card } from './ui/card';
import { Award, CheckCircle2 } from 'lucide-react';

const Achievements = ({ achievements }) => {
  return (
    <section id="achievements" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Professional Achievements
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Recognition and milestones in pediatric hematology and oncology
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Card className="p-8 sm:p-10 border-slate-200 shadow-lg">
            <div className="space-y-6">
              {achievements?.map((achievement, idx) => (
                <div
                  key={idx}
                  className="flex items-start space-x-4 p-4 rounded-lg hover:bg-teal-50 transition-colors duration-200 group"
                >
                  <div className="flex-shrink-0 mt-1">
                    <div className="p-2 bg-teal-100 rounded-lg group-hover:bg-teal-600 transition-colors duration-200">
                      <Award className="w-5 h-5 text-teal-600 group-hover:text-white" />
                    </div>
                  </div>
                  <p className="text-slate-700 text-lg leading-relaxed">
                    {achievement}
                  </p>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Achievements;